export const DEMO_PAGE_TITLE = 'Demo tècnica d’Aleta';

export const isDemoHostname = hostname => (
    typeof hostname === 'string' && hostname.toLowerCase().split('.')[0] === 'demo'
);

export const applyDemoSeo = (targetDocument, hostname) => {
    if (!targetDocument || !isDemoHostname(hostname)) return;

    targetDocument.title = DEMO_PAGE_TITLE;

    let robotsMeta = targetDocument.head.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
        robotsMeta = targetDocument.createElement('meta');
        robotsMeta.setAttribute('name', 'robots');
        targetDocument.head.appendChild(robotsMeta);
    }

    robotsMeta.setAttribute('content', 'noindex,follow');
};
